import { render, staticRenderFns } from "./subjectTem.vue?vue&type=template&id=649cd908&scoped=true&"
import script from "./subjectTem.vue?vue&type=script&lang=js&"
export * from "./subjectTem.vue?vue&type=script&lang=js&"
import style0 from "./subjectTem.vue?vue&type=style&index=0&id=649cd908&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "649cd908",
  null
  
)

export default component.exports